import routeDirectory from '~/navigation/routes'

/**
 * Used by the `AclGuard` to redirect the user from the index page
 */
export default function getHomeRoute() {
  return routeDirectory.dashboard.root
}
